import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer(val) {
    console.log(val)
    return {
      // 只储存state中的assessmentData
      active: val.active,
      acvityvi: val.acvityvi,
      shopingType: val.shopingType
    }
  }
})
export default new Vuex.Store({
  state: {
    isPopupText: false,
    isPopupName: '',
    LoginFailure: false,
    active: 0,
    isLoading: false,
    orderStatus: -100,
    acvityvi: -1,
    activity_batch_id: 0,
    shareStr: '',
    shopingType: null,
    navList: []
  },
  mutations: {
    increment(state, name) {
      // 变更状态
      state.isPopupText = name ? true : false
      state.isPopupName = name
    },
    LoginFailure(state, name) {
      state.LoginFailure = name
    },
    activeFailure(state, name) {
      state.active = name
    },
    isLoadingFg(state, name) {
      state.isLoading = name
    },
    orderStatusFg(state, name) {
      state.orderStatus = name
    },
    acvityviFg(state, name) {
      state.acvityvi = name
    },
    activityIdFg(state, name) {
      state.activity_batch_id = name
    },
    activityIdFg(state, name) {
      state.activity_batch_id = name
    },
    shareFg(state, name) {
      state.shareStr = name
    },
    shopFg(state, name) {
      console.log(state, name)
      state.shopingType = name
    },
    navFg(state, name) {
      console.log('------------------------------')
      state.navList = name
    }
  },
  getters: {},
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin]
});
